import React,{useState,useEffect,}from 'react'
import { Table,Space,Form, Flex,Tag,Button} from 'antd';
import Main from '../../cpn/Main'
import { useShangpingdingdanListQuery,} from '../../store/ReactWebSiteApi';
import WebGoodsOrderEdit from './WebGoodsOrderEdit';
import WebGoodsOrderDel from './WebGoodsOrderDel';
import GetWebGoods from '../goods/GetWebGoods';
import ClientCheck from '../client/ClientCheck';
import WebGoodsOrderAdd from './WebGoodsOrderAdd';
import ClientSelect from '../client/ClientSelect';
import WebGoodsTypeSelect from '../goodsType/WebGoodsTypeSelect';
import SonTypeSelect from '../goodsType/SonTypeSelect';
function WebGoodsOrderList() {
    const [query,setQuery] = useState({
        dd_e_id:localStorage.getItem('e_id'),
        dd_sub_type_id:'',
        dd_type_id:'',
        dd_eowgg_id:'',
        dd_eowg_id:'',
    })
    const {data,isSuccess} = useShangpingdingdanListQuery(query,{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {dd_id:key,dd_eowg_name,dd_eowgg_name,dd_eowgt_name,dd_eowgts_name,dd_byxkh_name,dd_uname,dd_ctime,dd_xf_date,dd_dq_date,dd_xf_amount,dd_xf_num,dd_byxkh_id,dd_qy_id,dd_content   } = item;
                    return item = {key,dd_eowg_name,dd_eowgg_name,dd_eowgt_name,dd_eowgts_name,dd_byxkh_name,dd_uname,dd_ctime,dd_xf_date,dd_dq_date,dd_xf_amount,dd_xf_num,dd_byxkh_id,dd_qy_id,dd_content}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.dd_ctime;
                    let bTimeString = b.dd_ctime;
                    return aTimeString - bTimeString;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [                               
        {
            key: 'state',
            title: '状态',
            render:(text,record) => {
                if (record.dd_dq_date && new Date(record.dd_dq_date) < new Date()) {
                    return<Tag color='red'>已过期</Tag>
                }else{
                    return<Tag color='green'>未过期</Tag>
                }
            }
        },        
        {
            key: 'dd_byxkh_name',
            title: '客户',
            dataIndex:'dd_byxkh_name',             
            render:(text,record) => {
                return  <ClientCheck 
                            byxkh_name={text}
                            byxkh_id={record.dd_byxkh_id}
                        />
            }
        },            
        {
            key: 'dd_eowg_name',
            title: '商品',
            dataIndex:'dd_eowg_name',                     
        },            
        {
            key: 'dd_eowgg_name',
            title: '规格',
            dataIndex:'dd_eowgg_name',                     
        },            
        {
            key: 'dd_eowgt_name',
            title: '商品类型',
            dataIndex:'dd_eowgt_name',                     
        },            
        {
            key: 'dd_eowgts_name',
            title: '系统名称',
            dataIndex:'dd_eowgts_name',                     
        },                           
        {
            key: 'dd_xf_date',
            title: '缴费日期',            
            dataIndex: 'dd_xf_date',           
        },
        {
            key: 'dd_dq_date',
            title: '到期日期',            
            dataIndex: 'dd_dq_date',           
        },
        {
            key: 'dd_xf_amount',
            title: '缴费金额',            
            dataIndex: 'dd_xf_amount',           
        },
        {
            key: 'dd_xf_num',
            title: '用户数',
            dataIndex: 'dd_xf_num'
        }, 
        {
            key: 'dd_qy_id',
            title: '企业id',
            dataIndex: 'dd_qy_id'
        },                      
        {
            key: 'time',
            title: '操作记录',
            render: (_,record) =><>{record.dd_ctime + record.dd_uname}</>
        },
        {
            key: 'key',
            title: '编号',
            dataIndex: 'key'
        },    
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>
                        <WebGoodsOrderEdit dd_id={record.key} />
                        <WebGoodsOrderDel dd_id={record.key} />
                    </Space>
                </>
            }
        },
    ]
    const [form] = Form.useForm();
    return (
        <Main selectedKeys={['/WebGoodsOrderList']}  >
            <Flex style={{ marginBottom: 16 }} justify='space-between'>
                    <Form
                        name='form_goods_order_list'
                        layout='inline'
                        form={form}
                        onFinish={(values) => {
                            setQuery(prev => ({...prev,dd_eowg_id:values.dd_eowg_id}))
                        }}
                    >
                        <WebGoodsTypeSelect
                            name='dd_eowgt_id'
                            wrapperCol={{span:10}} 
                            style={{width:'200px'}}
                            onChange={(e) => {
                                setQuery(prev => ({...prev,dd_eowgt_id:e}))
                            }}
                            label='商品类型'
                        />
                        <SonTypeSelect
                            name='dd_eowgts_id'
                            wrapperCol={{span:10}} 
                            style={{width:'200px'}}
                            onChange={(e,f) => {
                                setQuery(prev => ({...prev,dd_eowgts_name:f}))
                            }}
                            label='系统名称'
                            eowgt_id={query.dd_eowgt_id}
                        />
                        <GetWebGoods
                            name='dd_eowg_id'
                            formStyle={{marginBottom:'0'}}
                            style={{width:'200px'}}
                            onChange={(e) => {
                                setQuery(prev => ({...prev,dd_eowg_id:e}))
                            }}
                            label='商品'
                            eowg_type_id={query.dd_eowgt_id}
                            eowg_sub_type_id={query.dd_eowgts_id}
                        />
                        <ClientSelect
                            label='客户'
                            name='dd_byxkh_id'
                            wrapperCol={{span:10}} 
                            style={{width:'200px'}}
                            onChange={(e) => {
                                setQuery(prev => ({...prev,dd_byxkh_id:e}))
                            }}
                        />
                        <Form.Item >
                            <Space>
                                <Button 
                                     onClick={(e) => {
                                        form.submit()
                                }}>查询</Button>
                                <Button  onClick={() => {
                                    form.resetFields()
                                    setQuery(prev => ({...prev,dd_eowg_id:'',dd_byxkh_id:'',dd_eowgt_id:'',dd_eowgts_name:''}))
                                }}>重置</Button>
                            </Space>
                        </Form.Item>
                    </Form>     
                <WebGoodsOrderAdd />
            </Flex>         
            <Table columns={columns} dataSource={list}></Table>            
        </Main>
    )
}

export default WebGoodsOrderList